import { render, staticRenderFns } from "./ApprovalKPI.vue?vue&type=template&id=7770662c"
import script from "./ApprovalKPI.vue?vue&type=script&lang=js"
export * from "./ApprovalKPI.vue?vue&type=script&lang=js"
import style0 from "./ApprovalKPI.vue?vue&type=style&index=0&id=7770662c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports